import type1 from '../../assets/img/connectors/1_g@2x.png';
import type2 from '../../assets/img/connectors/2_g@2x.png';
import css from '../../assets/img/connectors/3_g@2x.png';
import chademo from '../../assets/img/connectors/4_g@2x.png';
import schuko from '../../assets/img/connectors/5_g@2x.png';
import cee3p from '../../assets/img/connectors/7_g@2x.png';
import cee1p from '../../assets/img/connectors/6_g@2x.png';

import type1w from '../../assets/img/connectors/1_w@2x.png';
import type2w from '../../assets/img/connectors/2_w@2x.png';
import cssw from '../../assets/img/connectors/3_w@2x.png';
import chademow from '../../assets/img/connectors/4_w@2x.png';
import schukow from '../../assets/img/connectors/5_w@2x.png';
import cee3pw from '../../assets/img/connectors/7_w@2x.png';
import cee1pw from '../../assets/img/connectors/6_w@2x.png';

let connectorImgs = {
  "connector-type1": type1,
  "connector-type2": type2,
  "connector-ccs": css,
  "connector-chademo": chademo,
  "connector-schuko": schuko,
  "connector-cee-3p": cee3p,
  "connector-cee-1p": cee1p,
}

let connectorActiveImgs = {
  "connector-type1": type1w,
  "connector-type2": type2w,
  "connector-ccs": cssw,
  "connector-chademo": chademow,
  "connector-schuko": schukow,
  "connector-cee-3p": cee3pw,
  "connector-cee-1p": cee1pw,
}

export { connectorImgs, connectorActiveImgs };